import React from 'react';
import {FormattedMessage, IntlProvider} from 'react-intl';

import {makeToolTipUrl} from "utils/DBUtils";
import {enUSmessage} from 'i18n/en-US.js';

export const StepControllingSweepsToolTip = (props) => (
  <div>
    Ties the sweepstakes to a certain step, forcing readers to complete the step in order to be entered.
  </div>
);

export const SetStartDayToolTip = (props) => (
  <div>
    The day the sweepstakes begins.
  </div>
);

export const SetEndDayToolTip = (props) => (
  <div>
    <strong>24 hours after</strong> the sweepstakes is complete.
  </div>
);

export const GrandPrizeToolTip = (props) => (
  <div>
    Typically, the largest prize included within the break.
  </div>
);

export const RunnerUpToolTip = (props) => (
  <div>
    Typically, the second largest prize within the break. Can be multiple or none.
  </div>
);

export const WeeklyPrizeToolTip = (props) => (
  <div>
    Used if a client wishes to award prizes weekly throughout their sweepstakes. There does not have to be a Grand Prize or Runner Up for there to be a Weekly.
  </div>
);

export const WeeklyPrizeDateLegalToolTip = (props) => (
  <div>
     Used when a client requests to include the date their weekly prize will be selected within the T&Cs.
  </div>
);

export const NumberOfPrizesToolTip = (props) => (
  <div>
    The total number of prizes. Including Grand, Runner Ups & Weeklies.
  </div>
);

export const ApproxValueAllPrizesToolTip = (props) => (
  <div>
    The combined value of ALL PRIZES. If there are 3, $10 weekly prizes being awarded, they would account for $30.
  </div>
);

export const ApplyStateFilterLegalToolTip = (props) => (
  <div>
    If yes, overwrites the standard abbreviated terms, which show at the bottom of the sweeps page, to show targeted states
    <br/>
    <img src={makeToolTipUrl('break/prizing/28.CMS-Apply-state-filters-to-legal.png')} width="100%"/>
  </div>
);

export const AddSponsorLegalToolTip = (props) => (
  <div>
    If the client is paying for the prizing they should be listed as the “sponsor” of the sweepstakes, this will appear in the T&C.
  </div>
);

export const CustomTermsAndConditionsToolTip = (props) => (
  <div>
    Use this field only if client modifications need to be made to Dailybreak’s standard T&Cs <strong>on the individual step level that prizing is tied to.</strong>
  </div>
);

export const AdditionalTermsAndConditionsToolTip = (props) => (
  <div>
    Use this field only if client modifications need to be made to Dailybreak’s standard T&Cs <strong>that appear on the landing page. </strong>
  </div>
);

export const AddOfficialRulesToolTip = (props) => (
  <div>
    Combines T&C’s into a single comprehensive document for legal purposes. Use this field only if the client’s campaign is being promoted in-store and or has a prize value exceeding $5,000.
  </div>
);



// WEBPACK FOOTER //
// ./public/components/break/tooltips/breaks-prizing-info-tool-tips.jsx